export default __webpack_public_path__ + "static/media/rate-good-icon.2852364f.svg";